export interface Theme {
  meta: {
    dark: boolean;
  };
  background: string;
  text: {
    default: string;
    secondary: string;
    tertiary: string;
    error: string;
    highlight: string;
  };
  disclaimer: {
    ssn: {
      background: string;
    };
  };
  header: {
    background: string;
    item: {
      selected: string;
      text: string;
    };
  };
  body: {
    background: string;
  };
  transfers: {
    item: {
      background: string;
    };
    option: {
      background: {
        selected: string;
        default: string;
      };
      text: {
        selected: string;
        default: string;
      };
    };
  };
  dashboard: {
    header: string;
    beneficiary: {
      item: {
        background: {
          selected: string;
          default: string;
        };
        text: {
          default: string;
        };
      };
    };
    deposit: {
      swirl: string;
    };
    beneficiarySsnBanner: {
      background: string;
      icon: string;
    };
  };
  accounts: {
    item: {
      goal: {
        background: string;
        text: string;
      };
      amount: {
        current: string;
        projected: string;
      };
      progress: {
        default: string;
        background: string;
      };
      empty: {
        default: string;
      };
    };
  };
  form: {
    background: string;
  };
  success: {
    background: string;
  };
  error: {
    background: string;
    disclaimer: {
      background: string;
      info: string;
    };
  };
  button: {
    background: {
      primary: string;
      secondary: string;
      disabled: string;
      danger: string;
      inverse: string;
    };
    text: {
      primary: string;
      secondary: string;
      inverse: string;
    };
  };
  verification: {
    banner: {
      home: {
        inProgress: string;
        error: string;
      };
      contributions: {
        inProgress: string;
        error: string;
      };
    };
  };
  chart: {
    projection: {
      default: {
        background: string;
        returned: string;
        invested: string;
        text: string;
        icon: string;
        footer: string;
        adjuster: {
          background: string;
          fill: string;
        };
      };
      inverted: {
        background: string;
        invested: string;
        returned: string;
        text: string;
        footer: string;
        switch: {
          icon: string;
          selected: string;
          background: string;
        };
      };
    };
    performance: {
      background: string;
      stroke: string;
      footer: {
        selected: {
          text: string;
          background: string;
        };
        disabled: {
          text: string;
        };
      };
    };
  };
  checkbox: {
    default: string;
    variant: string;
  };
  radio: {
    inner: string;
    filled: string;
    unfilled: string;
  };
  loader: {
    default: string;
    secondary: string;
    inverse: string;
  };
  goal: {
    icons: {
      trumpSidecar: string;
    };
    sidecar: {
      card: {
        background: string;
      };
      negative: string;
      positive: string;
    };
    progress: {
      background: string;
      bar: {
        background: string;
        default: string;
      };
    };
    deposits: {
      background: string;
      text: string;
    };
    share: {
      background: string;
      text: {
        default: string;
        secondary: string;
      };
    };
    portfolio: {
      seemore: {
        background: string;
        text: string;
      };
    };
    balanceSyncBanner: {
      background: string;
      icon: string;
    };
    harvest: {
      maximize: string;
      taxFiling: {
        background: string;
      };
    };
  };
  input: {
    background: string;
    text: string;
    placeholder: string;
    error: string;
    selected: {
      background: string;
      text: string;
    };
  };
  investment: {
    downturn: {
      stroke: string;
      fill: {
        first: string;
        second: string;
      };
      text: string;
      box: string;
      cursor: {
        fill: string;
        stroke: string;
      };
      dash: string;
      label: string;
    };
    breakdown: {
      card: {
        background: string;
        positive: string;
        negative: string;
        neutral: string;
      };
    };
  };
  item: {
    background: string;
    highlight: string;
  };
  icon: {
    default: string;
  };
  infoFill: {
    caution: {
      default: string;
      background: string;
    };
  };
  infoBanner: {
    background: string;
  };
  link: {
    default: string;
    secondary: string;
  };
  modal: {
    backdrop: string;
    background: string;
    item: string;
    button: {
      secondary: string;
    };
  };
  footer: {
    default: string;
    secondary: string;
  };
  border: string;
  exclusive: {
    default: string;
    inverse: {
      text: string;
      background: string;
    };
  };
  relink: {
    recurring: {
      background: string;
      icon: {
        background: string;
        fill: string;
      };
    };
  };
  documents: {
    unread: string;
  };
  validator: {
    valid: string;
    invalid: string;
  };
  switch: {
    background: string;
  };
  slider: {
    background: string;
  };
  progress: {
    default: string;
  };
  portfolio: {
    background: string;
  };
  card: {
    background: string;
  };
  tab: {
    selected: string;
    default: string;
  };
  auth: {
    icon: string;
    background: string;
    invest: {
      background: string;
    };
  };
  step: {
    complete: string;
    incomplete: string;
  };
  shared: {
    icon: {
      scheduled: {
        background: string;
      };
    };
    contribution: {
      default: string;
    };
    cta: {
      remove: string;
      resend: string;
      sent: string;
      cancel: string;
    };
    badge: {
      default: string;
    };
  };
  contact: {
    item1: string;
    item2: string;
    item3: string;
  };
  withdrawal: {
    success: {
      default: string;
      background: string;
    };
    availableFunds: {
      icon: string;
      default: string;
    };
    listItem: {
      background: string;
      border: string;
      fill: string;
    };
  };
  promo: {
    invalid: {
      background: string;
      icon: string;
      text: string;
    };
    valid: {
      default: string;
      icon: string;
    };
    allocate: {
      background: string;
      button: {
        background: string;
        text: string;
      };
      pending: {
        background: string;
        text: string;
      };
    };
  };
}

export interface ThemeStore {
  setTheme: (theme: Theme) => unknown;
  theme: Theme;
  selection: ThemeSelection;
  setSelection: (selection: ThemeSelection) => unknown;
}

export enum ThemeSelection {
  System = "system",
  Light = "light",
  Dark = "dark",
}
